// @flow
import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as bookingsCreators from '../../actions/bookings/bookingCreators';
import {
  getCurrentOrganisationInsightSets,
  getCurrentOrganisationShapeSets,
  setCurrentOrganisationOrLocation
} from '../../actions/organisations/organisationCreators';
import { getSetting } from '../../actions/settings/settingsCreators';
import { Grid, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import BookingSidebar from './BookingSidebar';
import BookingDetails from './BookingDetails';
import BookingHeader from '../../components/BookingHeader';
import LoadingSpinner from '../../components/LoadingSpinner';
import type { Dispatch } from 'redux';
import type { Organisation, Booking } from '../../types';

type Props = {
  params: {
    context: string,
    organisationId: string,
    bookingId: string
  },
  router: {
    push: (s: string) => void
  },
  currentOrganisation: Organisation,
  currentLocation: Object,
  currentBooking: Booking,
  settings: Object,
  bookings: Booking[],
  setCurrentOrganisationOrLocation: (o: number, c: string, s?: boolean) => void,
  updateCurrentBooking: (c: number, o: number) => Promise<*>,
  updateBooking: (c: Object, context: string, r: boolean) => void,
  getSetting: (s: string) => void,
  addBooking: Function,
  getBooking: Function
};

type State = {
  loading: boolean,
  currentStep: number
};

class Bookings extends React.Component<Props, State> {
  intervalId: IntervalID;

  constructor(props: Props) {
    super(props);
    this.state = {
      loading: true,
      currentStep: 1
    };
  }

  componentDidMount() {
    const {
      params: { context, organisationId, bookingId },
      setCurrentOrganisationOrLocation,
      updateCurrentBooking,
      getSetting
    } = this.props;

    getSetting('campaignHelpPdf');
    getSetting('campaignHelpVideo');
    this.pollLocalStorage();
    // Load currentOrganisation/currentLocation,
    if (
      this.props &&
      this.props.params &&
      this.props.params.context !== 'global'
    ) {
      setCurrentOrganisationOrLocation(parseInt(organisationId, 10), context);
    }

    // Load currentCampaign
    updateCurrentBooking(
      parseInt(bookingId, 10),
      parseInt(organisationId, 10)
    ).then(() => {
      this.setState({ loading: false });
    });
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  componentWillReceiveProps(nextProps: Props) {
    this.handleCurrentOrgChange(nextProps);
    this.handleCurrentLocationChange(nextProps);
    this.handleBookingIdUpdate(nextProps);
  }

  handleCurrentOrgChange = (nextProps: Props) => {
    const {
      router,
      params: { context }
    } = this.props;

    const newUrlId = nextProps.params.organisationId;
    const currentOrgId = this.props.currentOrganisation.id;
    const newCurrentOrgId = nextProps.currentOrganisation.id;

    // state org has changed to something other than the new urlId
    const currentOrgHasChanged =
      currentOrgId !== newCurrentOrgId &&
      newCurrentOrgId !== parseInt(newUrlId, 10);

    if (currentOrgHasChanged) {
      if (context === 'sub-account') {
        // redirect to dashboard
        router.push('/');
      } else {
        // update url back to /bookings
        router.push(`/customer/${newCurrentOrgId || ''}/bookings`);
      }
      if (
        this.props &&
        this.props.params &&
        this.props.params.context !== 'global'
      ) {
        setCurrentOrganisationOrLocation(newCurrentOrgId, context);
      }
    }
  };

  handleCurrentLocationChange = (nextProps: Props) => {
    // Update campaigns if currentLocation has changed
    const newCurrentLocation = nextProps.currentLocation;
    const currentLocation = this.props.currentLocation;
    const context = this.props.params.context;
    if (currentLocation.id !== newCurrentLocation.id) {
      if (context === 'sub-account') {
        // if context is location, redirect to /bookings page
        this.props.router.push(
          `/sub-account/${newCurrentLocation.id}/bookings`
        );
      }
      if (
        this.props &&
        this.props.params &&
        this.props.params.context !== 'global'
      ) {
        setCurrentOrganisationOrLocation(newCurrentLocation.id, context);
      }
    }
    // if context is customer, do nothing
  };

  handleBookingIdUpdate = nextProps => {
    const bookingId = this.props.params.bookingId;
    let newBookingId = nextProps.params.bookingId;

    // booking Id in URL has changed
    if (newBookingId !== bookingId) {
      const currentOrgId = this.currentOrgId();
      newBookingId = parseInt(newBookingId, 10);
      this.setState({ loading: true });
      this.props
        .updateCurrentBooking(newBookingId, currentOrgId)
        .then(() => this.setState({ loading: false }));
    }
  };

  currentOrgId = () => parseInt(this.props.params.organisationId, 10);

  updateBooking = () => {
    const updatedBooking = {
      ...this.props.currentBooking
    };
    const redirect = true;

    this.props.updateBooking(
      updatedBooking,
      this.props.params.context,
      redirect
    );
  };

  pollLocalStorage = () => {
    this.intervalId = setInterval(() => {
      /*
    AR: No idea what this does so commenting out
      const currentBookingRaw = localStorage.getItem(
        'reduxPersist:currentBooking'
      );
      let currentBooking;
      if (currentBookingRaw) {
        currentBooking = JSON.parse(currentBookingRaw);
      }*/
    }, 1000);
  };

  render() {
    const { settings, currentOrganisation, params } = this.props;
    return (
      <Grid fluid>
        <Helmet>
          {params && !params.bookingId && (
            <title>
              Manage Bookings |{' '}
              {currentOrganisation && currentOrganisation.name
                ? currentOrganisation.name + ' | '
                : ''}{' '}
              Campaign Targeter
            </title>
          )}
          {params && params.bookingId && (
            <title>
              Edit Booking | {currentOrganisation && currentOrganisation.name} |
              Campaign Targeter
            </title>
          )}
        </Helmet>
        <Row>
          <BookingHeader
            params={this.props.params}
            pdfUrl={
              settings && settings.campaignHelpPdf
                ? settings.campaignHelpPdf.value
                : ''
            }
            videoUrl={
              settings && settings.campaignHelpVideo
                ? settings.campaignHelpVideo.value
                : ''
            }
          />
        </Row>
        <Row>
          <Col sm={3} className="sidebar-wrapper">
            {/* $FlowFixMe */}
            <BookingSidebar
              {...this.props}
              currentOrgId={this.props.params.organisationId}
            />
          </Col>
          <Col sm={9} className="generic-main-content-wrapper">
            <div className="main-content">
              {this.state.loading && <LoadingSpinner />}
              {!this.state.loading && <BookingDetails {...this.props} />}
            </div>
          </Col>
        </Row>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    bookings: state.bookings,
    currentBooking: state.currentBooking,
    currentOrganisation: state.currentOrganisation,
    currentInsightSet: state.currentInsightSet,
    currentLocation: state.currentLocation,
    settings: state.settings
  };
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  return bindActionCreators(
    {
      ...bookingsCreators,
      getCurrentOrganisationInsightSets,
      getCurrentOrganisationShapeSets,
      setCurrentOrganisationOrLocation,
      getSetting
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Bookings);



// WEBPACK FOOTER //
// ./src/containers/bookings/Bookings.js